import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const ProjectStatusDetail = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const [item] = useState(location?.state?.item);

  const panelTitle = {
    fontSize: "18px",
    paddingTop: "10px",
    paddingBottom: "10px",
    texAlign: "left",
    fontWeight: 600,
  };
  const body = {
    padding: "10px",
    backgroundColor: "#fff",
    marginLeft: "20px",
    marginRight: "20px",
    borderWidth: "1px",
    borderRadius: "4px",
  };
  const subTitle = {
    fontSize: "14px",
    color: "#76838f",
  };
  const head = {
    fontSize: "16px",
    color: "#000",
  };
  return (
    <div className="page-content read container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="body" style={body}>
            <h1 style={panelTitle}>Name</h1>
            <p style={subTitle}>{item?.name}</p>
          </div>
          <div className="body" style={body}>
            <h1 style={panelTitle}>Name (Arbic)</h1>
            <p style={subTitle}>{item?.nameAr}</p>
          </div>
          
          <div className="body" style={body}>
            <h1 style={panelTitle}>Icon</h1>
            <div
              style={{
                width: "100px",
                height: "100px",
                display: "inline-block",
                marginRight: "10px",
                overflow: 'hidden',
              }}
            >
              <img src={item?.image} alt="icon" />
            </div>
          </div>
     
        </div>
      </div>
    </div>
  );
};

export default ProjectStatusDetail;
